export default __webpack_public_path__ + "static/media/IMG-20250105-WA0004.16d0b15e.jpg";